/**
 * The platform's own site (landing page, signup, console) lives on the
 * platform domain and www.<domain>. Helpdesks are <slug>.<domain> or custom
 * domains. VITE_PLATFORM_DOMAIN must match platform_settings.domain.
 *
 * Locally the domain is "localhost": plain localhost stays the helpdesk that
 * existed before multi-tenancy, the platform is www.localhost.
 */
export const platformDomain = (
  (import.meta.env.VITE_PLATFORM_DOMAIN as string | undefined) || 'localhost'
).toLowerCase();

export const platformName =
  (import.meta.env.VITE_PLATFORM_NAME as string | undefined) || 'Liquidesk';

/**
 * VITE_PLATFORM_HOST: the platform site's host when the domain itself is
 * another website (e.g. help.yourdesk.com). Helpdesks stay <slug>.<domain>.
 */
export const platformHost = ((import.meta.env.VITE_PLATFORM_HOST as string | undefined) || '').toLowerCase();

export function isPlatformHost(hostname = window.location.hostname) {
  const host = hostname.toLowerCase();
  if (platformHost) return host === platformHost;
  return host === `www.${platformDomain}` || (host === platformDomain && platformDomain !== 'localhost');
}

/** Url of a helpdesk on the platform domain, with the current port. */
export function helpdeskUrl(host: string, path = '') {
  const {protocol, port} = window.location;
  const withPort = port && host.endsWith(platformDomain) ? `${host}:${port}` : host;
  return `${protocol}//${withPort}${path}`;
}
